import Vue from "vue";
import moment from "moment";
import config from "../config";
import axios from "axios";
import _staticOptions from "./json/staticOptions.json"

const _mixins = {
  read(value) {
    // console.log(value)
  },
  dateNow(format) {
    return moment(new Date()).format(format);
  },
  monthNow(format) {
    return moment(new Date().setDate(1)).format(format);
  },
  objSort(property, sort) {
    var sortOrder = sort ? 1 : -1;
    return function(a, b) {
      /*
       * next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  },
  isAllowed(permission) {
    // return true;
    if (permission && localStorage.getItem("profile")) {
      // console.log('PROFILES: ',JSON.parse(localStorage.getItem('profile')));
      if(JSON.parse(localStorage.getItem('profile')).role_code ==="super-admin") return true;
      if (permission === "template-allow-all") return true;
      else {
        if (
          JSON.parse(localStorage.getItem("profile"))["role_id"] === -1 &&
          false
        ) {
          return true;
        } else {
          const _permission =
            JSON.parse(localStorage.getItem("permission")) || [];
          if (permission.split("|").length > 1) {
            const permissionArr = permission.split("|");
            var allowed = false;

            for (const perm of permissionArr) {
              if (_permission.includes(perm)) {
                allowed = true;
              }
            }

            return Boolean(allowed);
          } else {
            return Boolean(_permission.includes(permission));
          }
        }
      }
    } else return false;
  },
  relSeparator(item, index) {
    let arr = item.split("-");
    return arr[index];
  },
  togleClass(id, classname, boolean) {
    let component = document.getElementById(id);
    if (component) {
      if (boolean) {
        component.classList.add(classname);
      } else {
        component.classList.remove(classname);
      }
    }
  },
  changeLocale(language = "id") {
    Vue.$i18n.locale = language;
  },
  cleansingObj(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  },
  lock_period(date) {
    const now = new Date();

    const thisMonth = new Date();
    thisMonth.setDate(25);

    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    nextMonth.setDate(25);

    const prevMonth = new Date();
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    prevMonth.setDate(25);

    if (now.getDate() <= 25) {
      return date < prevMonth || date > thisMonth;
    } else {
      return date < thisMonth || date > nextMonth;
    }
  },
  lockNow(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return (
      date < today || date > new Date(today.getTime() + 1 * 23 * 3600 * 1000)
    );
  },
  async geocodeFromCoordinate(latitude, longitude) {
    if (!latitude || !longitude) {
      return {
        success: false,
        error_message: "Latitude & Longitude value is mandotary"
      };
    }

    return new Promise(async (resolve, reject) => {
      await axios
        .get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${config.apikey.gmap}&language=id`
        )
        .then(async response => {
          const addressComponent = response.data.results[0].address_components;
          const addressObject = {
            route: "",
            streetNumber: "",
            village: "",
            subdistrict: "",
            district: "",
            province: "",
            country: "",
            postal_code: ""
          };

          for (const value of addressComponent) {
            if (value.types.includes("street_number")) {
              addressObject.streetNumber = value.short_name;
            } else if (value.types.includes("route")) {
              addressObject.route = value.short_name;
            } else if (value.types.includes("administrative_area_level_5")) {
              addressObject.village = value.short_name;
            } else if (value.types.includes("administrative_area_level_4")) {
              addressObject.subdistrict = value.short_name;
            } else if (value.types.includes("administrative_area_level_3")) {
              addressObject.district = value.short_name;
            } else if (value.types.includes("administrative_area_level_2")) {
              addressObject.province = value.short_name;
            } else if (value.types.includes("administrative_area_level_1")) {
              addressObject.country = value.short_name;
            } else if (value.types.includes("postal_code")) {
              addressObject.postal_code = value.short_name;
            } else {
            }
          }

          if (
            addressObject.district &&
            addressObject.district.split(" ").includes("City")
          ) {
            addressObject.district =
              "Kota " + addressObject.district.split(" ")[0];
          }

          if (
            addressObject.province &&
            addressObject.province.split(" ").includes("City")
          ) {
            addressObject.province =
              "Kota " + addressObject.province.split(" ")[0];
          }
          addressObject.pinLink =
            "https://www.google.com/maps/search/?api=1&query=" +
            latitude +
            "," +
            longitude;

          // const position =
          await this.getCoordinates()
            .then(res => {
              addressObject.directionLink =
                "https://www.google.com/maps?saddr=" +
                res.coords.latitude +
                "," +
                +res.coords.longitude +
                "&daddr=" +
                latitude +
                "," +
                longitude;
            })
            .catch(err => {
              // console.log(err)
            });

          // Buang karakter Kec.
          addressObject.district = addressObject.district.replace("Kec. ", "");

          if (!addressObject.route) addressObject.route = "Unnamed Road";
          return resolve({
            success: true,
            result: {
              formatted_address: response.data.results[0].formatted_address,
              ...addressObject
            }
          });
        });
    });
  },
  getCoordinates() {
    return new Promise(function(resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true
      });
    });
  },

  idrFormat(value, afterValue = "") {
    return (
      new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value) + afterValue
    );
  },

  rgbToHex(r, g, b) {
    var value =
      "#" +
      [r, g, b]
        .map(x => {
          const hex = x.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("");

    return value.substring(0, 7);
  },

  landStatus(approve, complete) {
    if (!complete) {
      return {
        label: "Belum Lengkap",
        color: "warning-light"
      };
    } else if (complete && approve == 0) {
      return {
        label: "Lengkap, Belum Terverif",
        color: "info-light"
      };
    } else if (approve === 3) {
      return {
        label: "Force Majeure",
        color: "danger-light"
      };
    } else if (approve == 1) {
      return {
        label: "Terverifikasi",
        color: "success-light"
      };
    } else if (approve == 0) {
      return {
        label: "Belum Terverifikasi",
        color: "light"
      };
    }
  },

  avatarHelper(value) {
    if (typeof value !== "string" || !value || value.length < 2) return value;
    const valueArr = value.split(" ");

    if (valueArr.length > 1) {
      return `${valueArr[0].charAt(0).toUpperCase()}${valueArr[
        valueArr.length - 1
      ]
        .charAt(0)
        .toUpperCase()}`;
    } else if (valueArr.length == 1) {
      return `${valueArr[0].charAt(0)}${valueArr[0].charAt(1)}`;
    } else {
      return value;
    }
  },
  breadcrumbIcons(name) {
    if (!name) return null;

    let breadcrumb = name.replace(" ", "-").toLowerCase()
    
    const icons = {
      masters: 'ri-database-2-line',
      area: 'ri-signal-tower-line',
      provinces: 'ri-map-pin-line',
      cities: 'ri-map-pin-line',
      districts: 'ri-map-pin-line',
      villages: 'ri-map-pin-line',
      ethnic: 'ri-user-location-line',
      trees: 'ri-plant-line',
      project: 'ri-space-ship-line',
      'project-type': 'ri-file-settings-line',
      'options-section': 'ri-list-check-2',
    }
    if (icons[breadcrumb]) return icons[breadcrumb]
    else return null
  },

  userInfo() {
    const user = JSON.parse(localStorage.getItem('profile'))
    return user
  },

  staticOptions(field) {
    if (typeof _staticOptions[field] != 'undefined' && _staticOptions[field]) return _staticOptions[field]
    else return []
  },

  staticOptionLabel(value, field) {
    let options = []
    if (typeof _staticOptions[field] != 'undefined' && _staticOptions[field]) options = _staticOptions[field]
    
    const findData = options.find(v => v.code == value)
    if (!findData) return '-'
    else return findData.label
  },

  menuIconExcept(icon) {
    const excepts = [
      'node-tree'
    ]
    if (excepts.includes(icon)) return true
    else return false
  }
};
export default _mixins;



// WEBPACK FOOTER //
// ./src/utils/global.js